var _circle, _circle2, _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlitzLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#1e1b4b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    stroke: "#6366f1",
    strokeWidth: 2,
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,30) rotate(-8) translate(-32,-30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 50 C32 50 12 36 12 24 C12 16 18 12 24 12 C28 12 31 15 32 18 C33 15 36 12 40 12 C46 12 52 16 52 24 C52 36 32 50 32 50Z",
    fill: "#6366f1",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 50 C32 50 12 36 12 24 C12 16 18 12 24 12 C28 12 31 15 32 18 C33 15 36 12 40 12 C46 12 52 16 52 24 C52 36 32 50 32 50Z",
    fill: "url(#heartGrad)",
    opacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 22,
    x2: 18,
    y2: 22,
    stroke: "#818cf8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 30,
    x2: 16,
    y2: 30,
    stroke: "#818cf8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 38,
    x2: 17,
    y2: 38,
    stroke: "#818cf8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 20 L28 30 L33 30 L29 42 L38 28 L33 28 Z",
    fill: "#c7d2fe",
    opacity: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heartGrad",
    x1: 12,
    y1: 12,
    x2: 52,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#818cf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f46e5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlitzLogo);
export default __webpack_public_path__ + "static/media/flitz-logo.d85987680ca291850c8f37265105bb75.svg";
export { ForwardRef as ReactComponent };